export * from './components/Text/index';
//# sourceMappingURL=Text.js.map